import { humanize } from '@utils';
import { getMetricUnit, getMetricUnitText, LESS_THAN_NUMBER } from '@utils/metrics';
import { IMPROVEMENT_OPPORTUNITY_METRICS } from '@src/utils/kpi';

export const sortKPIMetricsData = (data = {}) => {
  const resultArray = IMPROVEMENT_OPPORTUNITY_METRICS.map((item) => ({
    name: item,
    value: data[item],
  }));
  return resultArray.sort((a, b) => (b.value ?? 0) - (a.value ?? 0));
};

export const getMetricTitle = (metricKey, value) => {
  if (isNaN(value)) {
    return 'NA';
  }
  const humanizedValue =
    value < LESS_THAN_NUMBER && value > 0 ? '<'.concat(LESS_THAN_NUMBER) : humanize(value, '');
  const unit = getMetricUnit({ metricKey });
  const units = getMetricUnitText(unit);
  return value !== undefined ? `${humanizedValue}${units}` : 'NA';
};
